import {useLocalStorage} from '~/common/hooks/useLocalStorage';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {InfoIcon} from '~library/svg/InfoIcon';
import {cottonCandy, tanzaniteWebText} from '~libSass/base/_exports.sass';

export const FirstVisit = () => {
  const [seen, setSeen] = useLocalStorage('event_details_seen', null);

  return (
    seen === null && (
      <div
        style={{
          color: tanzaniteWebText,
          background: cottonCandy,
          padding: '1rem',
          borderRadius: '0.5rem',
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1rem',
        }}
      >
        <InfoIcon color={tanzaniteWebText} ratio={3} />
        <Typography style={{margin: '0 0.25rem 0 1rem'}} variant="paragraph2">
          Event details appear below your invitation. Information added here will not show on the
          actual invitation.
        </Typography>
        <CloseLineIcon
          color={tanzaniteWebText}
          onClick={() => setSeen(true)}
          style={{cursor: 'pointer'}}
          ratio={1.75}
        />
      </div>
    )
  );
};
